import React from "react";
import HeaderWrapper from "../components/Header/HeaderWrapper";
import NavBar from "../components/Header/NavBar";
import Logo from "../components/Header/Logo";
import HeaderLink from "../components/Header/HeaderLink";
import FeatureWrapper from "../components/Header/FeatureWrapper";
import FeatureTitle from "../components/Header/FeatureTitle";

function HeaderCompound({ children }) {
  // Función para manejar el clic y redirigir a WhatsApp
  const handleWhatsAppClick = () => {
    const whatsappMessage = "Hola, quisiera contratar un plan de FibraLink";
    const whatsappLink = `https://wa.me/593990441331?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    window.open(whatsappLink, "_blank", "noopener,noreferrer");
  };

  return (
    <HeaderWrapper className="header-wrapper-home">
      <NavBar className="navbar-home">
        <Logo />
        <HeaderLink />
      </NavBar>
      <FeatureWrapper className="feature-wrapper-home">
        <FeatureTitle className="feature-title-home">
          La conexión perfecta: Rápida, confiable y accesible en tu ciudad!
          <div className="btn-container">
            {/* Botón que redirige a WhatsApp */}
            <button
              type="button"
              className="btn button"
              onClick={handleWhatsAppClick}
            >
              ¡Contrata ahora!
            </button>
          </div>
        </FeatureTitle>
      </FeatureWrapper>
      {children}
    </HeaderWrapper>
  );
}

export default HeaderCompound;
